import classnames from 'classnames';
import { CKContainerProps } from 'clearkit';

export function GetStarted({ className, ...rest }: CKContainerProps) {
  return (
    <div {...rest} className={classnames(className, 'text-center space-y-4')}>
      <h2 className="font-medium">Get started with Prospector</h2>
      <p className="text-gray-500">
        Create a new prospect list to hone in on available prospects and add
        them to your CRM or to a CSV for download.
      </p>
    </div>
  );
}
